module.exports = __webpack_public_path__ + "img/emoji_15.a82661dd.png";